import React from "react";
import { useTranslation } from "react-i18next";
import {
  ShowChartRounded,
  RequestQuoteRounded,
  ShoppingBasketRounded,
  ShoppingCartCheckoutRounded,
} from "@mui/icons-material";
import { Grid, IconButton, Paper, Typography } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { formatCurrency } from "../../hooks/Currency";

const SalesAccWidget = ({ sellsItem, expenses, purchases }) => {
  const { t } = useTranslation();
  const _store = useSelector((state) => state.pos.defStore);

  const [totalSells, setTotalSells] = useState(0);
  const [totalExps, setTotalExps] = useState(0);
  const [totalProfit, setTotalProfit] = useState(0);
  const [totalPurch, setTotalPurch] = useState(0);

useEffect(() => {
    const now = new Date();

    const isCurrentMonth = (dateValue) => {
      const date = new Date(dateValue);

      return (
        date.getFullYear() === now.getFullYear() &&
        date.getMonth() === now.getMonth()
      );
    };

    // Monthly sales
    const monthlySells = (sellsItem || []).filter((item) =>
      isCurrentMonth(item.sellDate)
    );

    const salesTotal = monthlySells.reduce(
      (sum, item) =>
        sum + Number(item.qty || 0) * Number(item.price || 0),
      0
    );

    setTotalSells(salesTotal);

    // Monthly gross profit
    const profitTotal = monthlySells.reduce((sum, item) => {
      const qty = Number(item.qty || 0);
      const price = Number(item.price || 0);
      const purchasePrice = Number(item.product?.purchPrice || 0);

      return (
        sum +
        (Number(item.itemType) === 1
          ? qty * (price - purchasePrice)
          : qty * price)
      );
    }, 0);

    setTotalProfit(profitTotal);

    // Monthly purchases
    const purchaseTotal = (purchases || [])
      .filter((item) => isCurrentMonth(item.purchDate))
      .reduce(
        (sum, purchase) =>
          sum +
          (purchase.purchItems || []).reduce(
            (itemSum, item) =>
              itemSum +
              Number(item.qty || 0) *
                Number(item.purchPrice || 0),
            0
          ),
        0
      );

    setTotalPurch(purchaseTotal);

    // Monthly expenses
    const expenseTotal = (expenses || [])
      .filter((item) => isCurrentMonth(item.addDate))
      .reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
      );

    setTotalExps(expenseTotal);
  }, [sellsItem, expenses, purchases]);

  return (
    <Grid container spacing={3} className="tx-upp">
      <Grid item xs={12} md={6}>
        <Paper className="p-20 br-8 shadow-xs">
          <Grid className="d-flex j-between a-center">
            <Typography variant="h5" className="gray-color fs-16 fw-5">
              {t("totalSales")}
            </Typography>
            <IconButton className="btn-primary">
              <ShoppingCartCheckoutRounded />
            </IconButton>
          </Grid>
          <Grid className="mt-20 mb-5">
            <Typography variant="h5" className="deepDark-color fw-5">
              {formatCurrency(totalSells, _store)}
            </Typography>
          </Grid>
        </Paper>
      </Grid>

      <Grid item xs={12} md={6}>
        <Paper className="p-20 br-8 shadow-xs">
          <Grid className="d-flex j-between a-center">
            <Typography variant="h5" className="gray-color fs-16 fw-5">
              {t("profit")}
            </Typography>
            <IconButton className="btn-primary">
              <ShowChartRounded />
            </IconButton>
          </Grid>
          <Grid className="mt-20 mb-5">
            <Typography variant="h5" className="deepDark-color fw-5">
              {formatCurrency(totalProfit, _store)}
            </Typography>
          </Grid>
        </Paper>
      </Grid>

      <Grid item xs={12} md={6}>
        <Paper className="p-20 br-8 shadow-xs">
          <Grid className="d-flex j-between a-center">
            <Typography variant="h5" className="gray-color fs-16 fw-5">
              {t("purchases")}
            </Typography>
            <IconButton className="btn-primary">
              <ShoppingBasketRounded />
            </IconButton>
          </Grid>
          <Grid className="mt-20 mb-5">
            <Typography variant="h5" className="deepDark-color fw-5">
              {formatCurrency(totalPurch, _store)}
            </Typography>
          </Grid>
        </Paper>
      </Grid>

      <Grid item xs={12} md={6}>
        <Paper className="p-20 br-8 shadow-xs">

          <Grid className="d-flex j-between a-center">
            <Typography variant="h5" className="gray-color fs-16 fw-5">
              {t("expense")}
            </Typography>
            <IconButton className="btn-primary">
              <RequestQuoteRounded />
            </IconButton>
          </Grid>

          <Grid className="mt-20 mb-5">
            <Typography variant="h5" className="deepDark-color fw-5">
              {formatCurrency(totalExps, _store)}
            </Typography>
          </Grid>
          
        </Paper>
      </Grid>
    </Grid>
  );
};

export default SalesAccWidget;
